<template>
  <div>
    <div class="comment-header">
      <p>
        <span class="comment-icon-wrapper">
          <i
            class="comment-icon"
            :class="[`comment-icon_${CommentTypes[comment.type]}`, CommentIcons[comment.type]]"
          />
        </span>
          {{ comment.createdBy }} |
          {{ comment.taskNumber }} |
          {{ formatDate(comment.createdAt) }} {{ comment.transitionName ? ' | ' + comment.transitionName : ''}} |
          {{ CommentLabels[comment.type] }} | {{$t('pages.taskDetails.comments.commentItemHeader.owner')}}:
      </p>
      <span
        v-if="canEditComment"
        class="comment-actions"
        @click="() => $emit('editComment', comment)"
      >
        <i class="feather-edit"/>
      </span>
    </div>
    <div class="comment-body">
      <div class="comment-avatar">
        <img
          ref="avatarImage"
          class="img-responsive"
          src="../../../../../public/static/assets/img/crls_avatar.png"
        >
      </div>
      <div class="comment-content" :class="{'comment-content-transition': comment.transitionName}">
        <template v-if="comment.reason">
          <p v-for="(reason, index) in reasons" :key="`reason-${index}`">{{ reason }}
          </p>
        </template>
        <p class="comment-content-wrapping">{{ comment.content }}</p>
      </div>
    </div>
  </div>
</template>

<script>
  import CommentMixin from '@/components/bundles/share/comment/CommentMixin.js'

  export default {
    mixins: [
      CommentMixin
    ],
    props: {
      comment: {
        type: Object,
        default: () => ({})
      },
      avatar: {
        type: String,
        default: ''
      },
      service: { type: String, required: true }
    },
    computed: {
      currentCommentConfig() {
        return this.commentTypesList.find(item => Number(item.value) === Number(this.comment.type))
      },
      canEditComment() {
        const hasPermission = this.$store.state.base.securityActions[this.service]?.includes('put_comment');
        const isOptionListTrue = this.currentCommentConfig?.metadata?.optionList ?? false;

        return hasPermission && isOptionListTrue;
      },
      CommentTypes() {
        return this.commentTypesList.reduce((acc, item) => ({ ...acc, [item.value]: item.type }), {});
      },
      CommentIcons() {
        return this.commentTypesList.reduce((acc, item) => ({ ...acc, [item.value]: item.icon }), {});
      },
      CommentLabels() {
        return this.commentTypesList.reduce((acc, item) => ({ ...acc, [item.value]: item.label }), {});
      },
      reasons () {
        if (!this.comment.hasOwnProperty('reason')) {
          return []
        }
        return typeof this.comment.reason === 'string' ?
          this.comment.reason.split(',').filter(el => el) :
          this.comment.reason.filter(el => el)
      }
    },
    methods: {
      formatDate (dateVal) {
        const date = new Date(dateVal)
        return date.toLocaleDateString('pl-PL') + ' ' + date.toLocaleTimeString('pl-PL').substr(0, 5)
      },
      convertImg (avatar) {
        if (avatar !== undefined) {
          return `data:image-png;base64,${avatar}`
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .comment-content-transition {
    background-color: #ff9281
  }

  .comment-header {
    display: flex;
    justify-content: space-between;
  }

  .comment-icon {
    font-size: 1.6rem;
    font-weight: 600;

    &_private { color: #e41a1a; }
    &_public { color: green; }
    &_internal { color: orange; }

    &-wrapper {
      margin-right: 1rem;
    }
  }

  .comment-content-wrapping {
    white-space: pre-wrap;
  }
</style>
